import styled from "styled-components";
import { useTheme } from "../context/theme-context";

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <ToggleButton
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-pressed={isDark}
      title={isDark ? "Light mode" : "Dark mode"}
    >
      <IconSun
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden
        $visible={!isDark}
      >
        <circle cx="12" cy="12" r="5" />
        <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
      </IconSun>
      <IconMoon
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden
        $visible={isDark}
      >
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </IconMoon>
    </ToggleButton>
  );
};

export default ThemeToggle;

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  background: transparent;
  cursor: pointer;
  transition: all var(--transition);
  color: var(--text-secondary);
  padding: 0;
  flex-shrink: 0;

  &:hover {
    background: var(--accent-bg-hover);
    color: var(--green);
    border-color: var(--border-accent);
  }

  &:focus-visible {
    outline: 2px solid var(--green);
    outline-offset: 2px;
  }
`;

const IconSun = styled.svg<{ $visible: boolean }>`
  display: ${({ $visible }) => ($visible ? "block" : "none")};
`;

const IconMoon = styled.svg<{ $visible: boolean }>`
  display: ${({ $visible }) => ($visible ? "block" : "none")};
`;
